import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SCREEN_ID_HOUSEHOLD_COLLECT_ROOMMATE_COUNT,
} from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import roommateOptionItems from 'client/helpers/roommateOptionItems';

import branch from 'client/core/branch';
import NavigatorActions from 'client/actions/Navigator';
import HouseholdActions from 'client/actions/Household';

import Navbar from 'client/components/Navbar';
import SrCheckboxList from 'client/components/SrCheckboxList';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

@withTransitionHook
@withScrollToTop
@branch({
  currentUser: ['currentUser'],
  roommateApplication: ['roommateApplication'],
})
@withScreenId(SCREEN_ID_HOUSEHOLD_COLLECT_ROOMMATE_COUNT)
class HouseholdCollectRoommateCountPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Invite Roommates to Apply | Sunroom Rentals',
  })

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this._onRoommateCountFormSubmit = this._onRoommateCountFormSubmit.bind(this);

    this.state = {
      roommateApplicationCountInput: props.roommateApplication.count || null,
    };
  }

  async _onRoommateCountFormSubmit(e) {
    e.preventDefault();
    const {
      match,
      dispatch,
    } = this.props;

    const { roommateApplicationCountInput } = this.state;

    await dispatch(HouseholdActions.roommateApplicationStep, {
      listingId: parseInt(match.params.listingId, 10),
      roommatePayload: {
        count: roommateApplicationCountInput,
      },
    });
  }

  _onRoommateCountChange = (event) => {
    this.setState({
      roommateApplicationCountInput: event,
    });
  }

  _onBack = () => {
    const {
      match: { params },
      dispatch,
    } = this.props;

    dispatch(NavigatorActions.replace, {
      to: `/application/${params.userId}/${params.listingId}/in-person-tour`,
    });
  }

  render() {
    const {
      roommateApplicationCountInput,
    } = this.state;

    const isDisabled = (
      roommateApplicationCountInput === null
    );

    return (
      <div className='page-inviteRoommates'>
        <div className='inviteRoommates'>
          <Navbar
            leftButton={(
              <div
                className='link back'
                onClick={this._onBack}
              />
            )}
          />
          <div className='stepContainer'>
            <div className='textContainer'>
              <h1>How many <span className='bold'>total adults</span> will live&nbsp;here?</h1>
              <span className='explainerText'>Only people 18 years or older.</span>
            </div>
            <div className='formContainer answers'>
              <form method='post' onSubmit={this._onRoommateCountFormSubmit}>
                <SrCheckboxList
                  optionList={roommateOptionItems}
                  onChange={this._onRoommateCountChange}
                  value={roommateApplicationCountInput}
                  multipleSelection={false}
                />
                <ButtonDeprecated
                  type='submit'
                  onClick={this._onRoommateCountFormSubmit}
                  disabled={isDisabled}
                >
                  next
                </ButtonDeprecated>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HouseholdCollectRoommateCountPage.displayName = 'HouseholdCollectRoommateCountPage';

export default HouseholdCollectRoommateCountPage;
